import { defineStore } from 'pinia';
import axios from 'axios';
export const userStore = defineStore('userStore',{
    state: () => ({
        userEmails: []
    }),
    getters: {
        userHasApprovedEmail() {
            return this.userEmails.length > 0
                ? this.userEmails.filter(email => email.status === 'APPROVED').length > 0
                : true;
        },
        pendingEmail() {
            return this.userEmails.length > 0
                ? this.userEmails.filter(email => email.status === 'PENDING')[0].email
                : null;
        },
    },
    actions: {
        clearUserStore() {
            this.userEmails = [];
        },
        getUserEmailsAction(params) {
            return axios.get(`/api/user/emails?${new URLSearchParams(params).toString()}`)
                .then((resp)=> {
                    this.userEmails = resp.data;
                });
        },
        removeUserEmailAction(email) {
            return axios.delete(`api/user/emails?email=${email}`);
        },
        getUserEmails(profiles) {
            let params = {};
            if (profiles.length > 0) {
                profiles.forEach((profile)=> {
                    params[`${profile.type.toLowerCase()}Id`] = profile.profileId;
                });
            }
            return this.getUserEmailsAction(params);
        },
        removePrevUserEmails() {
            const prevEmails = this.userEmails.filter((email)=> {
                return email.status === 'PENDING' && !email.primary;
            });

            if (prevEmails.length > 0) {
                prevEmails.forEach((email)=> {
                    this.removeUserEmailAction(email.email);
                });
            }
        }

    }
});